import React from "react"
import type { ButtonProps } from "@chakra-ui/react"
import { Button } from "@chakra-ui/react"
import type { StyleProps } from "@mallardbay/lib-react-components"

import type { PropsWithChildrenAndStyle } from "~components/shared/todo-lib-react-components/types"

interface Props extends PropsWithChildrenAndStyle {
    readonly leftIcon?: ButtonProps["leftIcon"]
    readonly rightIcon?: ButtonProps["rightIcon"]
    readonly onClick: ButtonProps["onClick"]
    readonly isLoading?: boolean
    readonly disabled?: boolean
    readonly isUnderlined?: boolean
}

export function TextButtonSmall({ style, ...props }: Props) {
    return <TextButtonBase sx={style} size="sm" {...props} />
}

// For internal use only. Not meant to be exported.
function TextButtonBase({
    sx,
    isUnderlined,
    ...props
}: ButtonProps & { readonly isUnderlined?: boolean }) {
    const styles = useStyles({ isUnderlined })

    return (
        <Button
            sx={{ ...styles.textButton, ...sx }}
            variant="link"
            colorScheme="info"
            {...props}
        />
    )
}

function useStyles({ isUnderlined }: { isUnderlined?: boolean }) {
    const textDecoration = isUnderlined ? "underline" : "none"

    const textButton: StyleProps = {
        textDecoration,
        "&:hover": { textDecoration },
        fontSize: "sm",
    }

    return { textButton }
}
